import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';

// Dev note (SE) - these interfaces only include a subset of all properties
// since the full list is not relevant to our needs. For full types, see:
// https://tools.hubteam.com/api-catalog/services/InboundDbPropertiesService-Unified/v4/spec/internal#operations-Property_Definition-post-%2Fproperties%2Fv4%2F%7BobjectType%7D%2Fmulti-get
export const MULTI_GET_PROPERTIES = registerQuery({
  fieldName: 'automation_ui_log_events_multiGetProperties',
  args: ['objectTypeId', 'propertyNames'],
  fetcher: ({
    objectTypeId,
    propertyNames
  }) => {
    return http.post(`properties/v4/${objectTypeId}/multi-get`, {
      data: propertyNames
    });
  }
});